import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

type StatusGetInfoDeclaracionJuradaCeseActividadParcial = {
  status: number | null;
  statusText: string | null;
};

const useGetInfoDeclaracionJuradaCeseActividadParcial = () => {
  const [loadingGetInfoDeclaracionJuradaCeseActividadParcial, setLoadingGetInfoDeclaracionJuradaCeseActividadParcial] = useState(false);
  const [successGetInfoDeclaracionJuradaCeseActividadParcial, setSuccessGetInfoDeclaracionJuradaCeseActividadParcial] = useState(false);
  const [errorGetInfoDeclaracionJuradaCeseActividadParcial, setErrorGetInfoDeclaracionJuradaCeseActividadParcial] = useState<any>(null);
  const [dataGetInfoDeclaracionJuradaCeseActividadParcial, setDataGetInfoDeclaracionJuradaCeseActividadParcial] = useState<any>(null);

  const [statusGetInfoDeclaracionJuradaCeseActividadParcial, setStatusGetInfoDeclaracionJuradaCeseActividadParcial] =
    useState<StatusGetInfoDeclaracionJuradaCeseActividadParcial>({
      status: null,
      statusText: null
    });

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apiRecord = new record.RecordService(BASE_URL, FUNCTIONS_KEY);

  const getInfoDeclaracionJuradaCeseActividadParcial = async (
    userId: string,
    _cb?: (data: any) => void
  ) => {
    setLoadingGetInfoDeclaracionJuradaCeseActividadParcial(true);
    setSuccessGetInfoDeclaracionJuradaCeseActividadParcial(false);
    setErrorGetInfoDeclaracionJuradaCeseActividadParcial(null);

    try {
      const res = await apiRecord.getInfoSolicitudDeclaracionJuradaParcial(userId);

      setStatusGetInfoDeclaracionJuradaCeseActividadParcial({
        status: res.status,
        statusText: res.statusText
      });

      setSuccessGetInfoDeclaracionJuradaCeseActividadParcial(true);
      setDataGetInfoDeclaracionJuradaCeseActividadParcial(res.data);

      if (typeof _cb === "function") {
        _cb(res.data);
      }

      return res.data;

    } catch (err: any) {

      setStatusGetInfoDeclaracionJuradaCeseActividadParcial({
        status: err?.response?.status || 500,
        statusText: err?.response?.statusText || "Error"
      });

      setErrorGetInfoDeclaracionJuradaCeseActividadParcial(err);
      console.error("Error en getInfoDeclaracionJuradaCeseActividadParcial:", err);

      throw err;

    } finally {
      setLoadingGetInfoDeclaracionJuradaCeseActividadParcial(false);
    }
  };

  return {
    getInfoDeclaracionJuradaCeseActividadParcial,
    loadingGetInfoDeclaracionJuradaCeseActividadParcial,
    successGetInfoDeclaracionJuradaCeseActividadParcial,
    errorGetInfoDeclaracionJuradaCeseActividadParcial,
    dataGetInfoDeclaracionJuradaCeseActividadParcial,
    statusGetInfoDeclaracionJuradaCeseActividadParcial
  };
};

export default useGetInfoDeclaracionJuradaCeseActividadParcial;
